// SewingMachineForm.jsx
import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaCheckCircle, FaEnvelope } from "react-icons/fa";
import axios from "axios";
import "./Form.css";
import "./SewingMachineForm.css";
import { GiSewingMachine } from "react-icons/gi";
import BASE_URL from "../constant";

const SewingMachineForm = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    age: "",
    aadharNumber: "",
    parentSpouseName: "",
    phone: "",
    address: "",
    city: "",
    pincode: ""
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};
    if (!formData.fullName.trim()) newErrors.fullName = "पूरा नाम भरना अनिवार्य है";
    if (!formData.age || formData.age < 18 || formData.age > 100) newErrors.age = "मान्य आयु भरें (18-100 वर्ष)";
    if (!formData.aadharNumber.trim() || !/^\d{12}$/.test(formData.aadharNumber)) newErrors.aadharNumber = "मान्य 12 अंकों का आधार नंबर भरें";
    if (!formData.phone.trim() || !/^\d{10}$/.test(formData.phone)) newErrors.phone = "मान्य 10 अंकों का मोबाइल नंबर भरें";
    if (!formData.address.trim()) newErrors.address = "पता भरना अनिवार्य है";
    if (!formData.city.trim()) newErrors.city = "शहर का नाम भरना अनिवार्य है";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: "" }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    setLoading(true);

    try {
      const response = await axios.post(
        `${BASE_URL}/api/v1/mail/sewing-form`,
        formData
      );

      if (response.data.success) {
        setSuccess(true);

        setFormData({
          fullName: "", 
          age: "",
          aadharNumber: "",
          parentSpouseName: "",
          phone: "",
          address: "",
          city: "",
          pincode: ""
        });

        setTimeout(() => setSuccess(false), 5000);
      }
    } catch (error) {
      console.error("Submission error:", error);
      alert("सर्वर त्रुटि। कृपया पुनः प्रयास करें।");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="sewing-form-page">
      <Container>
        <Row className="justify-content-center">
          <Col lg={8} md={10} sm={12}>
            <div className="form-container sewing-form">
              {/* Header */}
              <div className="form-header">
                {/* Trust Registration Info */}
                <div className="trust-info" style={{ textAlign: "center", marginBottom: "20px", paddingBottom: "15px", borderBottom: "1px solid #e0e0e0" }}>
                  <h3 style={{ fontSize: "1.1rem", fontWeight: "bold", color: "#2e7d32", marginBottom: "5px" }}>
                    LATE SURESH SINGH FOUNDATION® TRUST
                  </h3>
                  <p style={{ fontSize: "0.75rem", color: "#666", marginBottom: "5px" }}>
                    (Registered under Indian Trust Act.)
                  </p>
                  <p style={{ fontSize: "0.7rem", color: "#888", marginBottom: "0" }}>
                    Trust Regd.No :- 375/22 | 80G, 12A, Darpan Niti Aayog, Aatma Nirbhar Bharat, CSR-1
                  </p>
                </div>

                {/* Patron and Founder */}
                <div className="patron-founder" style={{ display: "flex", justifyContent: "space-between", marginBottom: "25px", gap: "20px" }}>
                  <div style={{ textAlign: "center", flex: 1 }}>
                    <div style={{ fontWeight: "bold", fontSize: "1rem", color: "#1b5e20" }}>Shri Shyam Nandan Singh</div>
                    <div style={{ fontSize: "0.8rem", color: "#666", fontStyle: "italic" }}>(Patron)</div>
                  </div>
                  <div style={{ textAlign: "center", flex: 1 }}>
                    <div style={{ fontWeight: "bold", fontSize: "1rem", color: "#1b5e20" }}>Kshitij Ranjan 'Suresh'</div>
                    <div style={{ fontSize: "0.8rem", color: "#666", fontStyle: "italic" }}>(Founder Chairman)</div>
                  </div>
                </div>

                <div className="form-badge">
                  <GiSewingMachine className="form-badge-icon" />
                  <span>सशक्तिकरण कार्यक्रम</span>
                </div>
                <h1 className="form-title">
                  महिला सशक्तिकरण हेतु <span className="highlight">सिलाई मशीन वितरण</span>
                </h1>
              
              </div>


              {/* Success Message */}
              {success && (
                <div className="success-message">
                  <FaCheckCircle className="success-icon" />
                  <div>
                    <strong>धन्यवाद!</strong>
                    <p style={{ margin: 0, fontSize: "0.85rem" }}>आपका आवेदन सफलतापूर्वक जमा कर दिया गया है। हम आपसे शीघ्र संपर्क करेंगे।</p>
                  </div>
                </div>
              )}

              {/* Form */}
              <form onSubmit={handleSubmit}>
                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label">
                      पूरा नाम <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      name="fullName"
                      className={`form-control ${errors.fullName ? 'error' : ''}`}
                      value={formData.fullName}
                      onChange={handleChange}
                      placeholder="अपना पूरा नाम लिखें"
                    />
                    {errors.fullName && <span className="error-message">{errors.fullName}</span>}
                  </div>

                  <div className="form-group">
                    <label className="form-label">
                      आयु <span className="required">*</span>
                    </label>
                    <input
                      type="number"
                      name="age"
                      className={`form-control ${errors.age ? 'error' : ''}`}
                      value={formData.age}
                      onChange={handleChange}
                      placeholder="आयु (वर्षों में)"
                    />
                    {errors.age && <span className="error-message">{errors.age}</span>}
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label">
                      आधार कार्ड संख्या <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      name="aadharNumber"
                      className={`form-control ${errors.aadharNumber ? 'error' : ''}`}
                      value={formData.aadharNumber}
                      onChange={handleChange}
                      placeholder="12 अंकों का आधार नंबर"
                      maxLength="12"
                    />
                    {errors.aadharNumber && <span className="error-message">{errors.aadharNumber}</span>}
                  </div>

                  <div className="form-group">
                    <label className="form-label">
                      माता/पिता/पति का नाम
                    </label>
                    <input
                      type="text"
                      name="parentSpouseName"
                      className="form-control"
                      value={formData.parentSpouseName}
                      onChange={handleChange}
                      placeholder="माता, पिता या पति का नाम लिखें"
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label">
                      फोन नंबर <span className="required">*</span>
                    </label>
                    <input
                      type="tel"
                      name="phone"
                      className={`form-control ${errors.phone ? 'error' : ''}`}
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="10 अंकों का मोबाइल नंबर"
                      maxLength="10"
                    />
                    {errors.phone && <span className="error-message">{errors.phone}</span>}
                  </div>

                  <div className="form-group">
                    <label className="form-label">
                      पिनकोड
                    </label>
                    <input
                      type="text"
                      name="pincode"
                      className="form-control"
                      value={formData.pincode}
                      onChange={handleChange}
                      placeholder="पिनकोड (6 अंक)"
                      maxLength="6"
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label className="form-label">
                    पता <span className="required">*</span>
                  </label>
                  <textarea
                    name="address"
                    className={`form-control ${errors.address ? 'error' : ''}`}
                    value={formData.address}
                    onChange={handleChange}
                    placeholder="गाँव, पोस्ट, थाना, जिला सहित पूरा पता लिखें"
                    rows="3"
                  />
                  {errors.address && <span className="error-message">{errors.address}</span>}
                </div>

                <div className="form-group">
                  <label className="form-label">
                    शहर <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    name="city"
                    className={`form-control ${errors.city ? 'error' : ''}`}
                    value={formData.city}
                    onChange={handleChange}
                    placeholder="शहर का नाम लिखें"
                  />
                  {errors.city && <span className="error-message">{errors.city}</span>}
                </div>

                <button type="submit" className="submit-btn" disabled={loading}>
                  {loading ? (
                    <>
                      <div className="spinner"></div>
                      जमा कर रहे हैं...
                    </>
                  ) : (
                    <>
                      <FaEnvelope className="btn-icon" />
                      आवेदन जमा करें
                    </>
                  )}
                </button>
              </form>

              {/* Footer Info */}
              <div className="form-footer">
                <p>
                  <strong>आयोजक:</strong> स्व० सुरेश सिंह फाउंडेशन® ट्रस्ट<br />
                  (ग्राम लई, बिहटा, पटना)
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default SewingMachineForm;